import { toast } from "react-toastify";
export default function ToastFile(message, type) {
  switch (type) {
    case "added":
      toast.success(message);
      break;
    case "updated":
      toast.info(message);
      break;
    case "deleted":
      toast.warning(message);
      break;
    case "error":
      toast.error(message);
      break;
    default:
      toast.info(message);
      break;
  }
}
